import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const DownloadDropdown = ({ isDisabled, onDownload }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleDropdown = () => {
    if (!isDisabled) setIsOpen(!isOpen);
  };

  const handleDownload = (format) => {
    setIsOpen(false);
    onDownload(format); // format: "csv" or "json"
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        disabled={isDisabled}
        className="px-4 py-2 bg-white text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 disabled:opacity-50 flex items-center justify-between gap-2"
      >
        Download Dataset
        <ChevronDown className="w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-[999]">
          <button
            onClick={() => handleDownload("csv")}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
          >
            📄 CSV
          </button>
          <button
            onClick={() => handleDownload("json")}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
          >
            🧾 JSON
          </button>
          <button
            onClick={() => handleDownload("jsonl")}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
          >
            📚 JSONL
          </button>
          <button
            onClick={() => handleDownload("hf")}
            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-blue-50"
          >
            🤗 HuggingFace
          </button>
        </div>
      )}
    </div>
  );
};

export default DownloadDropdown;